import BaseService from "./BaseService";

export default {
  images() {
    return BaseService.get(`casegrid_images`).then(response => {
      let data = [];
      if (response.data && response.data.data) {
        data = response.data.data;
      }
      return data;
    });
  }
};
